import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import ScrollToTopOnMount from '../Common/ScrollToTopOnMount';
import Zoom from '@material-ui/core/Zoom';

const images = [
  {
    url: `${process.env.PUBLIC_URL}/static/images/company.jpg`,
    title: '会社概要',
    width: '50%',
    to: '/company',
  },
  {
    url: `${process.env.PUBLIC_URL}/static/images/moeropro.jpg`,
    title: 'コンテンツ',
    width: '50%',
    to: '/contents',
  },
];
const topimage = {
  url: `${process.env.PUBLIC_URL}/static/images/topbg.jpg`,
  title: 'Enjoy your work and play with all your might!',
  subtitle: '仕事も遊びも全力で楽しもう！',
  width: '100%',
};
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 240,
    width: '100%',
  },
  image: {
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },

  topimage: {
    width: '100%',
    height: 400,
  },

  toptitle: {
    position: 'relative',
    color: 'white',
    top: '50%',
    left: '50%',
    fontFamily: 'sans-serif',
    fontSize: '2em',
    fontWeight: 'bold',
    transform: 'translate(-50%,-50%)',
    margin: 1,
    padding: 0,
  },

  topsubtitle:{
    position: 'relative',
    color: '#d1d1d1',
    top: '50%',
    left: '50%',
    fontFamily: 'sans-serif',
    fontSize: '1em',
    fontWeight: 'bold',
    transform: 'translate(-50%,-50%)',
    margin: 16,
    padding: 0,

  }
}));

export default function Home() {
  const classes = useStyles();

  return (
    <Zoom in={true}>
      <div>
      <ScrollToTopOnMount />
      <div className={classes.root}>
      <br/>
      {
        <div
          className={classes.topimage}
          style={{
            backgroundImage: `url(${(topimage.url)}`,
            width: classes.topimage.width,
            height: classes.topimage.height,
          }}
        >
          <p className={classes.toptitle}>
            {topimage.title}
          </p>
          <div className={classes.topsubtitle}>{topimage.subtitle}</div>
        </div>
      }
      <br/>

      {images.map(image => (
        <ButtonBase
          focusRipple
          key={image.title}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width: image.width,
            marginTop: '3px',
          }}
          component={Link}
          to={image.to}
        >
          <span
            className={classes.imageSrc}
            style={{
              backgroundImage: `url(${image.url})`,
            }}
          />
          <span className={classes.imageBackdrop} />
          <span className={classes.imageButton}>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.imageTitle}
            >
              {image.title}
              <span className={classes.imageMarked} />
            </Typography>
          </span>
        </ButtonBase>
      ))}
      </div>
      </div>
    </Zoom>
  );
}
